import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useFetch } from '@/modules/core/composables/useFetch'
import { useNotificationStore } from '@/modules/shared/stores/notification-store'

///////////////////////////////////////////////////////////////////////////////
// Types
///////////////////////////////////////////////////////////////////////////////

export type Outstanding = {
  documents_count: number
  incomplete_associated_entities_count: number
  invoices_count: number
}

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

export const useOutstandingStore = defineStore('dashboard/outstandingStore', () => {
  const route = useRoute()
  const notificationStore = useNotificationStore()
  const baseUrl = computed(() => `/v4/${route.params.slug}/group/outstandings`)

  const outstanding = ref<Outstanding>({
    documents_count: 0,
    incomplete_associated_entities_count: 0,
    invoices_count: 0,
  })

  const fetchOutstandings = async (cid: string = 'current') => {
    try {
      outstanding.value = await useFetch(`${baseUrl.value}?cid=${cid}`).get<Outstanding>()
    } catch (error) {
      console.error(error)
      notificationStore.enqueue('error', 'Outstandings failed to load')
    }
  }

  return {
    outstanding,

    fetchOutstandings,
  }
})
